import _ from 'lodash';

export const hasKeys = (obj, attrs) => {
    let tmp = obj;

    for(let i=0; i<attrs.length; ++i) {
        if(_.isUndefined(tmp[attrs[i]]))
            return false;
        // tmp = tmp[attrs[i]];
    }
    return true;
}

export const errors2String = (errors) => {
    let strErrors = '';
    strErrors = errors.join(', ');
    return strErrors;
}